import { yupResolver } from '@hookform/resolvers/yup'
import React from 'react'
import { useForm } from 'react-hook-form'
import Button from '../../components/button'
import Modal from '../../components/modal'
import { FormInput } from '../../wrappers/formInput'
import * as Yup from 'yup';

export type TimeSheetSubmitForm = {
    emailIds: string;

}

interface Props  {
  onClose?: any;
  onSubmit?: any;
  modalData?: any;
  submitButton?: boolean;
}

const validationSchema = Yup.object({
  emailIds: Yup.string().required("Field is required")
})

const TimeSheetSubmit: React.FC<Props> = ({
    onClose,
    onSubmit,
    modalData,
    submitButton
}) =>
{  

    const formOptions = {
        resolver:yupResolver(validationSchema)
      }
    
      const {
        register,
        handleSubmit,
        formState: { errors },
      } = useForm<TimeSheetSubmitForm>(formOptions);
   
  
  return (
      <Modal title={'Submit'} size='medium' onClose={onClose}>
          
          <form>
          <div className="half-form-wrap">
          <div className="form-group">
            <label className="lablel">Reporting Manager:</label>
            {modalData && modalData.reportingManager}
          </div>
          <div className="form-group">
            <label className="lablel">Reporting Manager Email:</label>
            {modalData && modalData.reportingManagerEmail}
          </div>
          </div>
          <div className="half-form-wrap">
          <div className="form-group">
            <label className="lablel">Project:</label>
            {modalData && modalData.project}
          </div>
          <div className="form-group">
            <label className="lablel">Pay period:</label>
            {modalData && modalData.payPeriod && modalData.payPeriod.startDate && new Date(modalData.payPeriod.startDate).toDateString().slice(3) + " - " + new Date(modalData.payPeriod.endDate).toDateString().slice(3)}
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <label className="lablel">Total working days in this month:</label>
            {modalData && modalData.calculations && modalData.calculations.totalWorkingDays}
          </div>
          <div className="form-group">
            <label className="lablel">Actual working days:</label>
            {modalData && modalData.calculations && modalData.calculations.actualWorkingDays}
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <label className="lablel">Holidays:</label>
            {modalData && modalData.calculations && modalData.calculations.holidays}
          </div>
          <div className="form-group">
            <label className="lablel">Leaves:</label>
            {modalData && modalData.calculations && modalData.calculations.leaves}
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <label className="lablel">Overtime:</label>
            {modalData && modalData.calculations && modalData.calculations.overtime ? modalData.calculations.overtime : 0}
          </div>
          <div className="form-group">
            <label className="lablel">Actual working hours:</label>
            {modalData && modalData.calculations && modalData.calculations.actualWorkingHours}
          </div>
              </div>
              <div className="form-group">
              <label className="lablel">Add more email id’s (Comma seperated)</label>    
              <FormInput<TimeSheetSubmitForm>
                  id="email"
                  type="text"
                  name="emailIds"
                  placeholder="Enter email here"
                  register={register}
                  errors={errors}
                />        
                  <p style={{fontSize:11}}>Please note that additinal emails added will receive a copy if your timesheet</p>
              </div>

              <div className="popupAction">
          <Button
            onClick={onClose}
            type="submit"
            variant="secondary"
            size="small"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit(onSubmit)}
            type="submit"
            variant="primary"
            size="small"
            disabled={submitButton}
          >
            Submit
          </Button>
        </div>
              </form>
    </Modal>
  )
}

export default TimeSheetSubmit